import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-special-list-item',
  templateUrl: './special-list-item.component.html',
  styleUrls: ['./special-list-item.component.css']
})
export class SpecialListItemComponent implements OnInit {
  @Input() data: any;

  formGroup: FormGroup;
  assetListArray: FormArray;

  ngOnInit(): void {
    this.assetListArray = new FormArray([]);

    if (this.data?.assetList?.length) {
      this.data.assetList.forEach((item: any) => {
        this.assetListArray.push(this.createAssetGroup(item));
      });
    }

    this.formGroup = new FormGroup({
      propertyKey: new FormControl(this.data?.propertyKey || ''),
      assetList: this.assetListArray
    });
  }

  createAssetGroup(item?: any): FormGroup {
    return new FormGroup({
      id: new FormControl(item?.id || ''),
      order: new FormControl(item?.order || this.assetListArray.length + 1)
    });
  }

  addAssetRow() {
    this.assetListArray.push(this.createAssetGroup());
  }

  removeAssetRow(index: number) {
    this.assetListArray.removeAt(index);
  }
}
